import { r as registerInstance, c as createEvent, h, H as Host } from './index-97874de0.js';

const menuSettingsItemCss = ":host{display:block}";
const IxMenuSettingsItemStyle0 = menuSettingsItemCss;

const MenuSettingsItem = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.labelChange = createEvent(this, "labelChange", 7);
        this.label = undefined;
    }
    watchLabel(newValue, oldValue) {
        this.labelChange.emit({
            name: 'ix-menu-settings-item',
            oldLabel: oldValue,
            newLabel: newValue,
        });
    }
    render() {
        return (h(Host, { key: 'f551c7e99242ecfced694c73d83c602dc944dfea' }, h("slot", { key: '11dad3b953eecbfcc967a41195426746f74637eb' })));
    }
    static get watchers() { return {
        "label": ["watchLabel"]
    }; }
};
MenuSettingsItem.style = IxMenuSettingsItemStyle0;

export { MenuSettingsItem as ix_menu_settings_item };

//# sourceMappingURL=ix-menu-settings-item.entry.js.map